import 'picturefill'; // IEで動作しない場合はオンにしてみる
// import 'es6-promise/auto';